import BaseFormPresenter from "../../../base/BaseFormPresenter";

class InquiriesViewPresenter extends BaseFormPresenter {
    async getObject() {
        const collection = this.view.getCollectionName();
        const id = this.object.id || this.view.getObjectId();
        if (id) {
            try {
                this.view.showProgress();
                const inquiry = await this.getObjectUseCase.execute(collection, id);
                this.object = inquiry;
                this.view.setObject(inquiry);
                this.view.hideProgress();

                // Now fetch client
                if (inquiry.client?.id) {
                    const client = await this.getObjectUseCase.execute("client", inquiry.client.id);
                    this.view.setState({ client });
                }
            } catch (error) {
                this.view.hideProgress();
                this.view.showError(error);
            }
        }
    }

}

export default InquiriesViewPresenter;
